import { Typography } from '@material-ui/core';
import sqLogo from 'assets/img/sure_quote_website_logo.png';
import React from 'react';

const ResultsPdf = props => (
	<React.Fragment>
		<div className="a4Page" style={{ padding: '20px' }}>
			<div style={{ textAlign: 'center' }}>
				<img
					style={{ width: '250px', margin: '0px auto 15px auto' }}
					src={sqLogo}
					alt="sqLogo"
				/>

				<Typography variant="title" style={{ margin: '15px 0px' }}>
					<strong>Financial Needs Analysis</strong>
				</Typography>

				<Typography variant="subheading" style={{ margin: '15px 0px' }}>
					Description : {props.fnaDetails.description}
				</Typography>

				<Typography variant="subheading" style={{ margin: '15px 0px' }}>
					Client : {props.fnaDetails.clientFullName}
				</Typography>

				<Typography variant="subheading" style={{ margin: '15px 0px' }}>
					Date : {props.fnaDetails.date_created}
				</Typography>
			</div>
		</div>
		<div className="page-break" />
		<div className="a4Page" style={{ padding: '20px' }}>
			<Typography variant="title">Balance Sheet</Typography>
			<div className="scale08">{props.balanceSheet}</div>
		</div>
		<div className="page-break" />
		<div className="a4Page" style={{ padding: '20px' }}>
			<Typography variant="title">CGT</Typography>
			<div className="scale08">{props.CgtSheet}</div>
		</div>
		<div className="page-break" />
		<div className="a4Page" style={{ padding: '20px' }}>
			<Typography variant="title">Executor Fees</Typography>
			<div className="scale08">{props.ExecutorsFeesSheet}</div>
		</div>
		<div className="page-break" />
		<div className="a4Page" style={{ padding: '20px' }}>
			<Typography variant="title">Estate Duty</Typography>
			<div className="scale08">{props.EstateDutySheet}</div>
		</div>
	</React.Fragment>
);

export default ResultsPdf;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/ResultsPdf/ResultsPdf.jsx